import { createContext, useContext } from 'react';

export const EditorContext = createContext();

export const useEditorContext = () => {
  return useContext(EditorContext);
};
